import React, { useEffect, useState } from 'react';

import api from '../../services/api';
import Accordion from './components/Accordion';
import * as S from './styles';

export default function ChangesRelease() {
  const [data, setData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const response = await api.get('releaserest');
      setData(response?.data);
    };
    fetchData();
  }, []);

  return (
    <S.Container>
      {data?.map((item, index) => (
        <Accordion props={item} open={index === 0} />
      ))}
    </S.Container>
  );
}
